<template>
  <button
    v-if="inProgress"
    disabled
    class="primary-btn cursor-pointer px-[32px] py-[16px] text-white bg-orange-500 rounded-full text-[16px] leading-none font-bold"
    :class="fullWidth ? 'w-full' : 'w-fit'"
    id="upload-btn"
  >
    Uploading...
  </button>
  <button
    v-else
    @click="onClick"
    class="primary-btn !animate-none cursor-pointer px-[32px] py-[16px] text-white bg-orange-500 rounded-full text-[16px] leading-none font-bold"
    :class="fullWidth ? 'w-full' : 'w-fit'"
    id="upload-btn"
    :disabled="disabled"
  >
    Confirm and continue
  </button>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    inProgress: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
});
</script>
